<template>
    <div class="form-group">
        <label :for="field.id">{{ name }}</label>
        <input :id="field.id" type="text" class="form-control" :name="name" />
    </div>
</template>

<script>
    export default {
        name: 'TextInput',
        props: [
            'fieldId',
        ],
        components: {},
        computed: {
            name() {
                return this.field.labels[this.field.labelsOrder[0]]
            },
            field() {
                const { state } = this.$store

                return state.fields[this.fieldId]
            },
        },
        methods: {},
    }
</script>

<style scoped>
</style>
